import React from 'react';
import dayjs from 'dayjs';
import { datejs } from '@block/utils';
import { Button, Icon } from '@block/plug';
import { StepsProps } from '@src/types/components';
import { LX } from '@src/consts';
// import Url from '@src/nodes/personInfo/url';
import tipMassage from './tipMassage.json';
import { decrypt, getHaiouUrl, getServiceType } from '../../utils';
import './index.scss';

interface Props {
  config: {
    status: StepsProps['status'] | number;
    employeeType?: string;
    isSign: number;
    userName?: string;
    step?: string;
    isOld?: boolean;
  };
}
interface State {
  display: string;
  // isRemoteEntry: boolean | null;
}
interface ButtonData {
  text?: string;
  hash?: string;
  link?: string;
}
// hr审核提示信息
class TipInfo extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      display: 'none',
      // isRemoteEntry: null,
    };
  }

  // async componentDidMount() {
  //   // 获取远程入职和S2仓信息
  //   const { isRemoteEntry } = (await doAction(Url.getEntryTypeAndComputer, {}, null)) || {};
  //   this.setState({
  //     // 是否远程入职
  //     isRemoteEntry,
  //   });
  // }

  // 展开或收起问题
  handleClick = () => {
    const { display } = this.state;
    this.setState({
      display: display === 'none' ? 'block' : 'none',
    });
  };

  // 点击按钮跳转
  buttonClick = async ({ text, hash, link }: ButtonData) => {
    const { userName } = this.props.config || {};
    const linkMap = {
      '#haiou#': {
        url: getHaiouUrl,
        bId: LX.MC.COMPUNTER,
        custom: () => {
          return {
            code: decrypt(localStorage.getItem('userCode') || ''),
            userName,
            time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
          };
        },
      },
    };
    const { url, bId, custom } = linkMap[link] || {};
    const tenantUid = 1;
    // 点击开始签署时，判断是否已经签署
    if (text === '开始签署') {
      window.open(link);
      // const win = window.open(link);
      // contentWin.focus();
      // const tipConfig = await doAction(Url.homeDetail, {});
      // if (tipConfig.step === 4) {
      //   win.close();
      //   window.location.reload();
      // } else {
      //   win.focus();
      // }
      // return;
    }
    if (url) {
      if (bId)
        window.LXAnalytics(
          'moduleClick',
          bId,
          {
            custom: custom?.(),
          },
          { cid: LX.PID },
        );
      window.open(url());
      return;
    }
    if (hash) {
      await getServiceType();
      if (!window.hasSign && window.signType !== 0) {
        window.location.href = `/#/candidate/${tenantUid}/sign`;
        return;
      }
      window.location.hash = `#/candidate/${tenantUid}${hash}`;
      // return;
    }
    // window.open(link);
  };

  // 将str字符串中的特殊标记字符替换成obj中对应属性值，并返回替换后字符串,不存在时返回原字符串
  replaceString = (str: string, obj: DefaultAny) => {
    // eslint-disable-next-line no-useless-escape
    const reguler = /\#(\w*)\#/;
    const element = str.match(reguler);
    if (element && !obj[element[1]]) {
      return null;
    }
    return element ? str.replace(reguler, obj[element[1]]) : str;
  };

  render() {
    const { config } = this.props; // 配置信息
    const { display } = this.state;
    let { step } = config;
    // const { isOld } = config;
    if (config.status === 'error') {
      step = 'fail';
    }
    // step = 5;
    const contextInfo = tipMassage[step];
    // console.error('contextInfo', config, tipMassage, step, contextInfo, config);
    const material = contextInfo?.[config?.employeeType] || contextInfo?.others; // 根据员工类型判断要准备的入职材料

    // isOid v4.2.0 版本之前在途数据（部分状态无账号信息），资产侧无法登录
    // v4.2.11 隐藏 申请办公电脑 按钮
    const computer = <></>;
    // isRemoteEntry === false && contextInfo?.computer && !isOld ? (
    //   <>
    //     <div className="tip-computer-title">{contextInfo.computer.text}</div>
    //     {contextInfo.computer.button && (
    //       <Button
    //         className="tip-button"
    //         type={contextInfo.computer.button.type}
    //         onClick={() => this.buttonClick(contextInfo.computer.button)}
    //       >
    //         {contextInfo.computer.button.text}
    //       </Button>
    //     )}
    //   </>
    // ) : null;
    return (
      <div className="tip-info">
        {contextInfo?.title && <div className="tip-title">{contextInfo?.title}</div>}
        {contextInfo?.tip && <div dangerouslySetInnerHTML={{ __html: this.replaceString(contextInfo?.tip, config) }} />}
        {contextInfo?.list && (
          <ul>
            {contextInfo?.list.map((v, i) => {
              const context = this.replaceString(v.tip, config);
              if (!context || context === v.hide) {
                return null;
              }
              return (
                <li key={i}>
                  <div className="tip-list-title">{v.title}</div>
                  <div className="tip-list-context" dangerouslySetInnerHTML={{ __html: context }} />
                </li>
              );
            })}
          </ul>
        )}
        {contextInfo?.table && (
          <table>
            <thead>
              <tr>
                {contextInfo?.table.th.map((v, i) => (
                  <th key={i}>{v}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {config[contextInfo?.table.obj].map((v, i) => {
                const tdName = contextInfo?.table.td;
                v.rejectDate = datejs(v.rejectDate).format('YYYY/MM/DD HH:mm:ss');
                return (
                  <tr key={i}>
                    {tdName.map((name) => (
                      <td key={name}>{v[name]}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        {material && (
          <ul>
            {material.map((v, i) => (
              <li key={i}>
                <div className="tip-list-title">{v}</div>
              </li>
            ))}
          </ul>
        )}
        {contextInfo?.hint && <div className="tip-hint">{contextInfo?.hint}</div>}
        {contextInfo?.button && (
          <Button
            className="tip-button"
            type={contextInfo.button.type}
            onClick={() => this.buttonClick(contextInfo?.button)}
          >
            {contextInfo?.button.text}
          </Button>
        )}
        {!contextInfo?.question && contextInfo?.computer && computer}
        {contextInfo?.question && (
          <div className="tip-question">
            <div className="tip-question-line" />
            {contextInfo?.computer && computer}
            <div className="tip-question-header" onClick={this.handleClick}>
              <Icon className="tip-question-icon" type={contextInfo?.question.icon} />
              <span className="tip-question-title"> {contextInfo?.question.title}</span>
              <Icon className="tip-question-icon" type={display === 'none' ? 'caret-down' : 'caret-up'} />
            </div>
            <ul style={{ display }}>
              {contextInfo?.question.list.map((v, i) => (
                <li key={i}>
                  <div className="tip-list-title">{v.title}</div>
                  <div className="tip-list-context" dangerouslySetInnerHTML={{ __html: v.tip }} />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}

export default TipInfo;
